import {
    AKAMAI_LOC_ZIPCODE_SUCCESS,
    AKAMAI_LOC_ZIPCODE_INITIATE,
    AKAMAI_LOC_ZIPCODE_ERROR,
} from '../actionTypes/LocationActionTypes';

const locationReducer = function locationReducer(state = {}, action) {
    switch (action.type) {
        case AKAMAI_LOC_ZIPCODE_SUCCESS:
            return {
                value: action.akZipcode,
                status: 'success',
            };

        case AKAMAI_LOC_ZIPCODE_ERROR:
            return {
                value: null,
                status: 'fail',
            };

        case AKAMAI_LOC_ZIPCODE_INITIATE:
            return {
                value: null,
                status: 'pending',
            };

        default:
            return state;
    }
};

locationReducer.reducerName = 'akZipcode';

export default locationReducer;
